import { Award, Gavel, PieChart } from 'lucide-react';

import { TranslateFn } from 'hooks/useTranslate';

import { LoginSlideData } from './types';

export const generateLoginSlides = (t: TranslateFn): LoginSlideData[] => [
  {
    key: 'captable',
    SlideIcon: PieChart,
    color: '#6576ff',
    title: t('LoginCaptableTitle'),
    body: t('LoginCaptableBody'),
  },
  {
    key: 'plans',
    SlideIcon: Award,
    color: '#7de1f8',
    title: t('LoginPlansTitle'),
    body: t('LoginPlansBody'),
  },
  {
    key: 'boards',
    SlideIcon: Gavel,
    color: '#ffa9ce',
    title: t('LoginBoardsTitle'),
    body: t('LoginBoardsBody'),
  },
];
